/**
 * Strips HTML tags from a string and returns a plain-text excerpt.
 * @param html - The HTML markup to excerpt
 * @param maxLength - The maximum excerpt length before truncating with an ellipsis
 */
export function getExcerpt(html: string, maxLength = 160): string {
  const text = html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  return text.length > maxLength ? text.slice(0, maxLength).trimEnd() + "…" : text;
}

/**
 * Estimates reading time in minutes based on a 200 wpm reading speed.
 * @param html - The HTML markup to estimate reading time for
 */
export function getReadTime(html: string): number {
  const words = html.replace(/<[^>]+>/g, " ").trim().split(/\s+/).length;
  return Math.max(1, Math.ceil(words / 200));
}
